import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { api } from '@/lib/api';

export function ReconnectButton({
  accountId,
  onStarted,
}: {
  accountId: string;
  onStarted: (workflowId: string) => void;
}) {
  const m = useMutation({
    mutationFn: () => api.reconnectAccount(accountId),
    onSuccess: (res) => {
      toast.success('Reconnecting — logging in with the saved credentials…');
      onStarted(res.workflow_id);
    },
    onError: (err) => toast.error('Reconnect failed', { description: String(err) }),
  });
  return (
    <Button size="sm" variant="primary" onClick={() => m.mutate()} disabled={m.isPending}>
      {m.isPending ? 'Reconnecting…' : 'Reconnect'}
    </Button>
  );
}
